import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["offcanvas"];

    connect() {
        this.offcanvasTarget.addEventListener('show.bs.offcanvas', this.show.bind(this));
        this.offcanvasTarget.addEventListener('hide.bs.offcanvas', this.hide.bind(this));
        // document.getElementById('filters-btn-lg').click()
    }

    show() {
        document.body.classList.add('offcanvas-open');
        document.getElementById('filters-btn-lg').style.display = 'none'
    }

    hide() {
        document.body.classList.remove('offcanvas-open');
        if (document.getElementById('filters-btn-lg')) {
            document.getElementById('filters-btn-lg').style.display = 'block';
        }
    }
}